import { render } from "./tab-vaccines.vue?vue&type=template&id=a563d278&scoped=true"
import script from "./tab-vaccines.vue?vue&type=script&lang=js"
export * from "./tab-vaccines.vue?vue&type=script&lang=js"

import "./tab-vaccines.vue?vue&type=style&index=0&id=a563d278&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a563d278"]])

export default __exports__